import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import cx from 'classnames'
import {Button} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import phonez from '../../core/phonez'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import {Contact as PatrimonyContact} from '../../patrimony/models'
import patrimonyI18n from '../../patrimony/i18n'
import i18n from '../i18n'
import style from './TicketCallerCard.less'

class TicketCallerCard extends Component {
    static propTypes = {
        ticketIdLock: PropTypes.string,
        onSubmit: PropTypes.func
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {dispatch, ticket, patrimony, patrimonyContact, ticketIdLock, onSubmit, ...others} = this.props

        const cardHeader = (title) => (
            <h5>{title}</h5>
        )

        const callerName = (caller) => {
            if (caller.uid) {
                return (
                    <a
                        href=''
                        onClick={(e) => this._navigate(e, '/patrimonycontacts/' + caller.uid)}>
                        <h5>
                            <span>{caller.name}</span>
                            <Icon icon='plus' size='xs' />
                        </h5>
                    </a>
                )
            }

            return (
                <h5>{caller.name}</h5>
            )
        }

        const isLocked = () => {
            if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true
            return !ticket
        }

        return (
            <div className={style.default}>
                <Card
                    header={cardHeader(i18n.callerIdentity)}
                    {...others}>
                    {!isLocked() && (
                        <div>
                            {callerName(ticket.caller)}
                            {ticket.caller.uid == (patrimonyContact && patrimonyContact.uid) && (
                                <div className={style.comment}>
                                    {PatrimonyContact.filterLinkedWith(patrimonyContact, {patrimony}).map((link, index) => (
                                        <p key={index}>{PatrimonyContact.extractLinkedWith(patrimonyI18n.patrimonyContactLinkTypeEnum, link)}</p>
                                    ))}
                                </div>
                            )}
                            <ul className={style.contact}>
                                {ticket.caller.medium.filter((m) => m.mediumType == 'PHONE').map((medium, index) => (
                                    <li key={index}>
                                        <Icon icon='phone' size='xs' />
                                        <span> {phonez(medium.identifier).format()}</span>
                                    </li>
                                ))}
                            </ul>
                            <ul className={style.contact}>
                                {ticket.caller.medium.filter((m) => m.mediumType == 'MAIL').map((medium, index) => (
                                    <li key={index}>
                                        <Icon icon='mail' size='xs' />
                                        <span> {medium.identifier}</span>
                                    </li>
                                ))}
                            </ul>
                            <ul className={style.contact}>
                                {ticket.caller.medium.filter((m) => m.mediumType == 'FAX').map((medium, index) => (
                                    <li key={index}>
                                        <Icon icon='fax' size='xs' />
                                        <span> {phonez(medium.identifier).format()}</span>
                                    </li>
                                ))}
                            </ul>
                            {ticket.caller.comment && (
                                <div className={cx(style.comment, style.warning)}>qsdf
                                    <p>{ticket.caller.comment}</p>
                                </div>
                            )}
                            {onSubmit && (
                                <ul className={style.callingGroup}>
                                    <li>
                                        {ticket._links.find(linkFinder('EmitCallTo')) && (
                                            <Button
                                                onClick={(e) => onSubmit(e, 'EmitCallTo', ticket.caller)}>
                                                <p>{i18n.emitCallz}</p>
                                                <Icon icon='emitCall' size='sm' />
                                            </Button>
                                        )}
                                    </li>
                                    <li>
                                        {ticket._links.find(linkFinder('ReceiveCall')) && (
                                            <Button
                                                onClick={(e) => onSubmit(e, 'ReceiveCall', ticket.caller)}>
                                                <p>{i18n.receiveCallz}</p>
                                                <Icon icon='receiveCall' size='sm' />
                                            </Button>
                                        )}
                                    </li>
                                </ul>
                            )}
                        </div>
                    )}
                    {isLocked() && (
                        <div className={style.noTicketInfo}>
                            <span>{i18n.noTicketInfo}</span>
                        </div>
                    )}
                </Card>
            </div>
        )
    }
}

TicketCallerCard = connect((state) => ({
    ticket: state.ticket.ticket,
    patrimony: state.patrimony.patrimony,
    patrimonyContact: state.patrimony.contact.contact
}))(TicketCallerCard)

export default TicketCallerCard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketClaimCallerCard.js